var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "div",
        [
          !_vm.$root.sub
            ? _c(
                "div",
                {
                  staticClass: "productcompact productcompactWhite productbuy",
                  attrs: { "data-productpriceid": _vm.id },
                  on: { mouseenter: _vm.showProductImagesOnClick },
                },
                [
                  _c(
                    "div",
                    { staticClass: "priceWrap" },
                    [
                      _c("div", { staticClass: "productquantity clearfix" }, [
                        _c("p", [_vm._v(_vm._s(_vm.strippedQuant))]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "productprice",
                          staticStyle: { "padding-right": "8px" },
                        },
                        [
                          _vm.prices.price != "NaN" && !_vm.hidePrice
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getVisString(_vm.prices.price)
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm.prices.discount > 0 || this.$root.iscompany == 1
                        ? _c("additionalInfo", {
                            attrs: {
                              data: _vm.prices,
                              companyPriceIncludingVat: _vm.getVisString(
                                _vm.prices.companyPriceIncludingVat
                              ),
                              listPrice: _vm.getVisString(_vm.prices.listPrice),
                              localDiscount: _vm.getVisString(
                                _vm.prices.discount
                              ),
                              tax: _vm.tax,
                              showBuyButton: true,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.prices.promotionAttributes &&
                  _vm.prices.promotionAttributes.length > 0
                    ? _c("PromotionLabel", {
                        attrs: { promotion: _vm.prices.promotionAttributes },
                      })
                    : _vm._e(),
                  _vm.loaded
                    ? _c("buybutton", {
                        ref: "buybutton",
                        staticClass: "productcompactBuyButton",
                        on: { gtag: _vm.gtag },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          !_vm.$root.sub && _vm.admin && !_vm.oldurl
            ? _c("selectversion", { attrs: { prices: _vm.prices } })
            : _vm._e(),
          _vm.$root.sub
            ? _c("ProductPicker", {
                attrs: {
                  admin: _vm.admin,
                  localadmin: _vm.localadmin,
                  oldurl: _vm.oldurl,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }